import Vue from 'vue'

const eventBus = new Vue()

export default eventBus

export const eventType = {
  // 提交打包出货订单
  SubmitOrder: 'SubmitOrder',
  // 更新收件人地址
  UpdatedAddress: 'UpdatedAddress',
  // 包裹附加服务付費
  ParcelVaorderPay: 'ParcelVaorderPay',

  OpenResetPasswordDialog: 'OpenResetPasswordDialog',
  OpenSetPayPwdDialog: 'OpenSetPayPwdDialog',
  OpenUpdatePhoneDialog: 'OpenUpdatePhoneDialog',
  OpenPostDetaildDialog: 'OpenPostDetaildDialog',
  BalanceChange: 'BalanceChange',
  OpenBkacctCreateDialog: 'OpenBkacctCreateDialog',
  OpenTipsCrx: 'OpenTipsCrx',
  StartImportOrderBySearch: 'StartImportOrderBySearch',
  OpenPurchaseProof: 'OpenPurchaseProof',
  PurchaseProofImported: 'PurchaseProofImported',
  ViewImages: 'ViewImages',
  OpenCommentDetailDialog: 'OpenCommentDetailDialog',
  ReloadParcelOrder: 'ReloadParcelOrder',

  SwipeActionsOpen: 'SwipeActionsOpen',

  ExtrudeParcel: 'ExtrudeParcel', // 凸顯顯示包裹
  UpdateParcel: 'UpdateParcel', // 更新包裹
  RemoveParcel: 'RemoveParcel', // 包裹从列表中移除

  /**
   * 当App/当前展示页面被唤起的时候就会调用这个方法，唤起包括第一次打开App/当前展示页面，就会调用一次这个方法，App/当前展示页面，被用户切换到后台了，重新从后台唤起到前台操作的时候调用一次
   */
  APPonResume: 'APP_onResume',
  /**
   * 当App/当前展示页面被切换到后台进程，这个时候App会调用这个方法，表示用户现在已经停止操作这个应用了，在后台进程了
   */
  APPonPause: 'APP_onPause',
  /**
   * App/当前展示页面被进程销毁的时候会调用，表示这个页面或者App被销毁了
   */
  APPonDestroy: 'APP_onDestroy',

  /**
   * 当A页面开启B页面，B页面關閉的时候想把部分数据传回给A页面，则调用actSetIntentContentForResult方法，如果B页面没有调用，则不会触发这个方法
   */
  APPonActivityResult: 'APPonActivityResult',
  /**
   * web是监听app的返回键时，用户在当前页面点击返回页面的时候，app会调用web的handleKeyBack()方法
   */
  APPhandleKeyBack: 'APP_handleKeyBack',
  APPreceiveScreenshots: 'APPreceiveScreenshots',
  APPonColorMode: 'APPonColorMode',
  APPreceiveProgress: 'APPreceiveProgress',
  APPreceiveSubmitToS3Complete: 'APPreceiveSubmitToS3Complete',
  APPreceiveMotionBegan: 'APPreceiveMotionBegan',
  APPreceiveMotionEnded: 'APPreceiveMotionEnded',

  OpenReplyReviewComment: 'OpenReplyReviewComment',

  OpenParcelServiceConfirmDialog: 'OpenParcelServiceConfirmDialog', // 确认附加服务
  CheckPayDelayOrder: 'CheckPayDelayOrder', // 检查并显示未付款订单
  ViewVaorderDuListUnpay: 'ViewVaorderDuListUnpay', // 检查并显示未付款订单
  ErrorReportScreenshots: 'ErrorReportScreenshots',

  Offline: 'Offline',
  NewDeviceNeedCellphoneCaptcha: 'NewDeviceNeedCellphoneCaptcha',
  ToLogin: 'ToLogin',
}

Vue.prototype.$eventBus = eventBus
Vue.prototype.$eventType = eventType
